import React, { useState } from 'react';
import {
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Box,
} from '@chakra-ui/react';
import { MdOutlineRefresh } from 'react-icons/md';
import moment from 'moment';
import { TransactionType, TransactionPaymentMethod } from 'config/constant';
import Card from 'components/card/Card';
import TransactionStatus from './transactionStatus';

const TransactionTable = (props) => {
  const transactionList = props.transactions;
  const orderStatus = props.orderStatus;

  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <Flex
      height='100%'
      direction='column'>
      <Card
        mt={4}
        direction='column'
        bgColor='gray.200'
        w='100%'
        minHeight='12rem'
        maxHeight='42rem'
        px='0px'
        overflowX='scroll'>
        <Flex overflow='visible'>
          <Table
            variant='simple'
            color='gray.500'
            mb='24px'>
            <Thead>
              <Tr>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Transaction no.
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Type of Transaction
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Transaction Date
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Payment Method
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Status
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Amount
                  </Flex>
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {transactionList?.map((obj, index) => {
                return (
                  // <Link to={{ pathname: '/permission-group', state: obj.id }}>
                  <Tr key={obj.id}>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {obj.id.toString().slice(0, 8)} ( {obj.code} )
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {
                            TransactionType.find(
                              (option) => option.value === obj?.transaction_type
                            )?.label
                          }
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {moment(obj.transaction_date).format(
                            'DD MMM YY, HH:mm'
                          )}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {
                            TransactionPaymentMethod.find(
                              (option) => option.value === obj?.payment_method
                            )?.label
                          }
                          {obj?.payment_source ? ` (${obj.payment_source})` : ''}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <TransactionStatus
                        propFunct={props.propFunct}
                        status={obj.status}
                        id={obj.id}
                        orderStatus={props.orderStatus}
                        paymentMethod={obj.payment_method}
                      />
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {obj.amount}
                        </Text>
                      </Flex>
                    </Td>
                  </Tr>
                  // </Link>
                );
              })}
            </Tbody>
          </Table>
        </Flex>
      </Card>
    </Flex>
  );
};

export default TransactionTable;
